import BasicLabel from '../BasicLabel';
import React from 'react';
import './LabelWithCount.scss';

interface LabelWithCount {
  label: string;
  isRequired: boolean;
  baseNumber: string | number;
  count: number;
}

const LabelWithCount = (props: LabelWithCount): JSX.Element => {
  const { label, isRequired, baseNumber, count } = props;
  return (
    <div>
      <BasicLabel label={label} isRequired={isRequired} />
      <p className="limit">
        <span className="purchase-review-length">{count}</span> / {baseNumber}
      </p>
    </div>
  );
};

export default LabelWithCount;
